import classNames from 'classnames'
export type IconButtonSize = 'smaller' | 'small' | 'normal' | 'medium' | 'large'
export type IconButtonIconSize = 'small' | 'medium' | 'large'
export type IconButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'destructive'
  | 'quiet'
  | 'haze'
  | 'highlighted'
  | 'transparent'
  | 'secondary-ai'
  | 'custom'

export type BorderRadius = 'radius-normal' | 'radius-large'
export const BASE_CLASSES =
  'flexbox flexbox-centered border-none flexbox-no-shrink transition'

export const ICON_BUTTON_VARIANT_CLASSES: Record<
  IconButtonVariant,
  {
    base: string
    default: string
    isActive: string
    disabled: string
  }
> = {
  primary: {
    base: 'white',
    default:
      'background-primary background-primary-hover-on-hover background-primary-active-on-active',
    disabled: 'background-alpha-shade-55 shade-30',
    isActive: 'background-blue-20 background-blue-40-on-dark-mode',
  },
  secondary: {
    base: 'background-alpha-shade-55',
    default: classNames(
      'shade-10 background-alpha-shade-55',
      'background-alpha-shade-45-on-hover background-alpha-shade-45-on-active'
    ),
    disabled: 'shade-30 background-alpha-shade-55',
    isActive: 'shade-10 background-alpha-shade-45',
  },
  tertiary: {
    base: 'background-transparent',
    default:
      'shade-10 background-alpha-shade-50-on-hover background-shade-45-on-active',
    disabled: 'shade-40',
    isActive: 'background-shade-45 shade-10',
  },
  quiet: {
    base: 'background-transparent',
    default:
      'shade-30 background-alpha-shade-50-on-hover background-alpha-shade-45-on-active shade-10-on-hover',
    disabled: 'shade-40',
    isActive: 'background-alpha-shade-45 shade-10',
  },
  haze: {
    base: 'shade-100',
    default:
      'background-alpha-shade-40 background-alpha-shade-30-on-hover background-alpha-shade-20-on-active',
    disabled: '',
    isActive: 'background-alpha-shade-20',
  },
  destructive: {
    base: 'font-weight-extrabold border-none',
    default: classNames(
      'red-40 background-alpha-red-50',
      'background-alpha-red-45-on-hover background-alpha-red-40-on-active'
    ),
    disabled: 'background-alpha-shade-55 shade-30',
    isActive: 'background-alpha-red-40 red-40',
  },
  highlighted: {
    base: 'border-small border-transparent',
    default:
      'blue-20 background-alpha-blue-50 background-alpha-blue-45-on-hover',
    disabled: 'background-alpha-shade-55 shade-30',
    isActive: 'background-alpha-blue-45 blue-30 blue-20-on-dark-mode',
  },
  transparent: {
    base: 'background-transparent',
    default: '',
    disabled: '',
    isActive: '',
  },
  'secondary-ai': {
    base: 'font-weight-semibold border-small border-transparent',
    default: classNames(
      'purple-10 background-alpha-purple-50',
      'background-alpha-purple-45-on-hover',
      'background-alpha-purple-40-on-active'
    ),
    disabled: 'shade-30 background-alpha-shade-55 border-transparent',
    isActive: 'purple-10 background-alpha-shade-40',
  },
  custom: {
    base: 'icon-button icon-button--custom',
    default: '',
    disabled: 'icon-button--disabled',
    isActive: 'icon-button--active',
  },
}

export const iconButtonSize: Record<IconButtonSize, number> = {
  smaller: 20,
  small: 28,
  normal: 32,
  medium: 36,
  large: 44,
}
export const iconSizes: Record<IconButtonIconSize, number> = {
  small: 12,
  medium: 14,
  large: 16,
}
